import en from './en';
import es from './es';
import esES from './es-ES';

export default {
    en,
    es,
    'es-ES': esES,
};
